export interface IFavouriteRelease {
    id: string;
    favourite: boolean;
}

export class FavouriteRelease implements IFavouriteRelease {
    public favourite = false;

    constructor(
        public id: string,
    ) { }
}
